"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootInvestorSaga = void 0;
var effects_1 = require("redux-saga/effects");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var InvestorAction_1 = require("@/pages/investor/actions/InvestorAction");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var WindowApi_1 = require("@/api/browser/WindowApi");
var EnquireApiToken_1 = require("@/api/remote/protected/EnquireApiToken");
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var EnquireApiSaga_1 = require("@/pages/common/sagas/api/EnquireApiSaga");
var watchInvestorSubmit = function () {
    var payload, enquiry, currencyId, currentUrl, request, languageCode, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.take(InvestorAction_1.default.ON_INVESTOR_SUBMIT)];
            case 1:
                payload = (_a.sent()).payload;
                enquiry = payload;
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentCurrency)];
            case 2:
                currencyId = _a.sent();
                return [4 /*yield*/, effects_1.select(WindowApi_1.getCurrentUrl)];
            case 3:
                currentUrl = _a.sent();
                request = {
                    firstName: enquiry.firstname,
                    lastName: enquiry.lastname,
                    fullName: enquiry.fullname,
                    email: enquiry.email,
                    message: enquiry.comment,
                    enquiryType: EnquireApiToken_1.EnquireRequestType.Investors,
                    salutation: enquiry.salutation,
                    phone: enquiry.phone,
                    currencyType: currencyId,
                    enquiryData: {
                        company: enquiry.company,
                        referralUrl: currentUrl,
                    },
                };
                return [4 /*yield*/, effects_1.put(InvestorAction_1.default.setLoading(true))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 5:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnquireApiSaga_1.enquireApiSubmit, request, languageCode)];
            case 6:
                response = _a.sent();
                if (!(!response || response.data.hasError)) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiCallError'))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('enquireSuccess'))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [4 /*yield*/, effects_1.put(InvestorAction_1.default.setLoading(false))];
            case 11:
                _a.sent();
                return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
var rootInvestorSaga = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    watchInvestorSubmit: watchInvestorSubmit,
};
exports.rootInvestorSaga = rootInvestorSaga;
